/**
 * Color palette ported verbatim from bouncieweb's `theme/colors.js`.
 *
 * The ported landing pages are faithful reproductions of the original
 * Emotion-styled pages, so the section components reference these exact brand
 * hex values (rather than the new project's semantic design tokens) to preserve
 * the original look. Kept in one place so every ported section shares the same
 * source of truth.
 */
export const colors = {
  green: "#81B81A",
  green2: "#81B81A",
  greenDark1: "#5E8612",
  blue: "#1F69F2",
  blueHover: "#0954E0",
  blueDark1: "#112F60",
  blueDark2: "#1F2A3F",
  zachBlack: "#2A3141",
  blueDark4: "#0B1019",
  blueDark5: "#091F49",
  blueDark6: "#0C2A61",
  blueDark7: "#023083",
  blueDark9: "#2F3C55",
  blueLight1: "#F2F5F9",
  blueLight2: "#B2C3E3",
  blueLight3: "#D9E4F8",
  blueLight4: "#EAF0FE",
  blueLight5: "#BDCEF1",
  blueLight6: "#EDF3FF",
  blueLight7: "#F7FAFF",
  blueLight8: "#E1EDFD",
  blueLight9: "#9EBDF4",
  blueLight10: "#D5E3FF",
  blueLight11: "#A5C3FA",
  blueLight12: "#7AA3F0",
  blueGrayLight1: "#BFC7D6",
  blueGrayLight2: "#EEF3FB",
  white: "#ffffff",
  gray: "#888888",
  gray2: "#BFC2C9",
  grayDark1: "#767C86",
  grayDark2: "#4A4E54",
  grayDark3: "#595D65",
  grayLight1: "#D5D5D5",
  grayLight2: "#F2F2F2",
  grayLight3: "#F8FBFF",
  grayLight4: "#E9ECED",
  grayLight5: "#E0E7F5",
  grayLight6: "#DFDFDF",
  grayLight7: "#EAEBEE",
  grayLight8: "#E6E6E6",
  grayLight9: "#DCE5FF",
  grayLight10: "#EEF3FA",
  grayLight11: "#E9F0FE",
  grayLight12: "#d9e0f1",
  grayLight13: "#EBEEF3",
  grayLight14: "#E6E8EA",
  fadedBlack2: "#0B1019",
  fadedBlack3: "#3F3F41",
  fadedBlack4: "#5C5C5C",
  fadedBlack5: "#1E1F22",
  fadedBlack6: "#161A21",
  orange: "#F5BD23",
  orange2: "#FAD20B",
  orangeAmazon: "#FF6200",
  red: "#F21F1F",
  red2: "#E92C3B",
  purple: "#805A96",
  black: "#000000",
  fadedGray: "rgba(48, 48, 48, 0.5)",
} as const;
